import styled from 'styled-components'

import Link from 'components/icons/LinkIcon'
import { Form as AntdForm ,DatePicker, Radio as AntdRadio} from 'antd'

export const Heading = styled.div`
  font-weight: 600;
  font-size: 1.1428571428571428em;
  line-height: 21px;
  color: #1b1f22;
`

export const Text = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 1em;
  line-height: 18px;
  color: #3249d7;
`
export const LocalLink = styled(Link)`
  right: 40px;
`
export const LinkWrap = styled.div`
  margin-top: 12px;
`
export const FormItem = styled(AntdForm.Item)`
margin-top: 0px;
margin-bottom: ${props =>
  props.marginbottom ? props.marginbottom : '0px'} !important;
width: 100%;
.ant-form-item-explain-error {
  padding-left: ${props => (props.padding ? '15%' : '0')};
}
.ant-form-item-control-input {
  min-height: 0px;
}
`
export const DateStyles = styled(DatePicker)`
  margin-top: 5px;
  width: ${props => (props.width ? props.width : '100%')};
  height: 50px;
  padding: 10px 20px;
  background: #fafafb;
  border: 1px solid #e6e7ea;
  border-radius: 8px;
  line-height: 24px;
  &:focus {
    outline: none;
    opacity: 1;
    box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
    background-color: #ffffff;
  }
  &:focus::placeholder {
    color: transparent;
  }
  &::placeholder {
    opacity: 0.4;
  }
  &:hover {
    border: 1px solid #e6e7ea;
  }
  .ant-picker-input > input {
    font-size: 1.1428571428571428em;
    font-weight: 500;
  }
`
export const RadioGroup = styled(AntdRadio.Group)`
  display: flex;
  gap: 15px;
  margin-top: 8px;
  ${props => props?.spaceBetween && 'justify-content: space-between;'}
  `